module.exports = __webpack_public_path__ + "img/no-results.465627e.svg";